<template>
  <div>
    <div class="cuebiq-rate-widget">
      <svg xmlns="http://www.w3.org/2000/svg" version="1.1" :viewBox="viewBox" shape-rendering="crispEdges" image-rendering="optimizeQuality" color-rendering="optimizeQuality">
        <defs>
          <clipPath id="clipping">
            <circle cx="30" cy="25" r="15"></circle>
            <circle cx="70" cy="25" r="15"></circle>
            <circle cx="110" cy="25" r="15"></circle>
            <circle cx="150" cy="25" r="15"></circle>
            <circle cx="190" cy="25" r="15"></circle>
          </clipPath>
        </defs>
        <circle cx="30" cy="25" r="15"></circle>
        <circle cx="70" cy="25" r="15"></circle>
        <circle cx="110" cy="25" r="15"></circle>
        <circle cx="150" cy="25" r="15"></circle>
        <circle cx="190" cy="25" r="15"></circle>
        <rect x="0" y="0" :width="rectWidth" :height="height" clip-path="url(#clipping)" fill="#93E5A4"></rect>
      </svg>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'uplift-rating',
    props: {
      width: {
        type: Number,
        default: 220
      },
      height: {
        type: Number,
        default: 50
      },
      max: {
        type: Number,
        required: true
      },
      value: {
        type: Number,
        required: true
      }
    },
    computed: {
      viewBox : function() {
        return "0 0 " + this.width + " " + this.height;
      },
      rectWidth : function() {
        return (this.value / this.max) * this.width;
      }
    },
    mounted () {
    },
    methods: {
    }
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/UpliftRating.vue